import React, { FC, ReactNode, useState } from "react";
import { LocaleContext, type LocaleContextType } from "./LocaleContext";

interface LocaleProviderProps {
  children: ReactNode;
}

/**
 * Provider component for locale context
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child components
 */
export const LocaleProvider: FC<LocaleProviderProps> = ({ children }) => {
  const [locale, setLocale] = useState<string | undefined>(undefined);

  const value: LocaleContextType = {
    locale,
    setLocale,
  };

  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
};
